import React from "react";
import { SelectableProductsFilterContext } from "./context";

export const useSelectableProductsFilterContext = () => {
  const context = React.useContext(SelectableProductsFilterContext);
  if (!context) {
    throw new Error(
      "useSelectableProductsFilterContext must be used within a SelectableProductsFilterProvider"
    );
  }
  return context;
};
